export const FETCH_NORMALORDERS_INIT_ACTION = 'FETCH_NORMALORDERS_INIT_ACTION';
export const FETCH_NORMALORDERS_SUCCESS_ACTION =
  FETCH_NORMALORDERS_INIT_ACTION + '_SUCCESS';
export const FETCH_NORMALORDERS_FAIL_ACTION =
  FETCH_NORMALORDERS_INIT_ACTION + '_ERROR';

export const FETCH_INPROGRESSORDERS_INIT_ACTION =
  'FETCH_INPROGRESSORDERS_INIT_ACTION';
export const FETCH_INPROGRESSORDERS_SUCCESS_ACTION =
  FETCH_INPROGRESSORDERS_INIT_ACTION + '_SUCCESS';
export const FETCH_INPROGRESSORDERS_FAIL_ACTION =
  FETCH_INPROGRESSORDERS_INIT_ACTION + '_FAIL';

export const FETCH_DELIVEREDORDERS_INIT_ACTION =
  'FETCH_DELIVEREDORDERS_INIT_ACTION';
export const FETCH_DELIVEREDORDERS_SUCCESS_ACTION =
  FETCH_DELIVEREDORDERS_INIT_ACTION + '_SUCCESS';
export const FETCH_DELIVEREDORDERS_FAIL_ACTION =
  FETCH_DELIVEREDORDERS_INIT_ACTION + '_FAIL';

export const FETCH_CANCELLEDORDERS_INIT_ACTION =
  'FETCH_CANCELLEDORDERS_INIT_ACTION';
export const FETCH_CANCELLEDORDERS_SUCCESS_ACTION =
  FETCH_CANCELLEDORDERS_INIT_ACTION + '_SUCCESS';
export const FETCH_CANCELLEDORDERS_FAIL_ACTION =
  FETCH_CANCELLEDORDERS_INIT_ACTION + '_FAIL';

export const FETCH_NORMALORDERVIEW_INIT_ACTION =
  'FETCH_NORMALORDERVIEW_INIT_ACTION';
export const FETCH_NORMALORDERVIEW_SUCCESS_ACTION =
  FETCH_NORMALORDERVIEW_INIT_ACTION + '_SUCCESS';
export const FETCH_NORMALORDERVIEW_FAIL_ACTION =
  FETCH_NORMALORDERVIEW_INIT_ACTION + '_ERROR';

export const EDIT_NORMALORDER_INIT_ACTION = 'EDIT_NORMALORDER_INIT_ACTION';
export const EDIT_NORMALORDER_SUCCESS_ACTION =
  EDIT_NORMALORDER_INIT_ACTION + '_SUCCESS';
export const EDIT_NORMALORDER_FAIL_ACTION =
  EDIT_NORMALORDER_INIT_ACTION + '_ERROR';

export const FETCH_NORMALORDERREJECT_INIT_ACTION =
  'FETCH_NORMALORDERREJECT_INIT_ACTION';
export const FETCH_NORMALORDERREJECT_SUCCESS_ACTION =
  FETCH_NORMALORDERREJECT_INIT_ACTION + '_SUCCESS';
export const FETCH_NORMALORDERREJECT_FAIL_ACTION =
  FETCH_NORMALORDERREJECT_INIT_ACTION + '_ERROR';

export const GET_COMPLETEITEMS_INIT_ACTION = 'GET_COMPLETEITEMS_INIT_ACTION';
export const GET_COMPLETEITEMS_SUCCESS_ACTION =
  GET_COMPLETEITEMS_INIT_ACTION + '_SUCCESS';
export const GET_COMPLETEITEMS_FAIL_ACTION =
  GET_COMPLETEITEMS_INIT_ACTION + '_FAIL';

export const CREATE_INVOICE_INIT_ACTION = 'CREATE_INVOICE_INIT_ACTION';
export const CREATE_INVOICE_SUCCESS_ACTION =
  CREATE_INVOICE_INIT_ACTION + '_SUCCESS';
export const CREATE_INVOICE_FAIL_ACTION = CREATE_INVOICE_INIT_ACTION + '_FAIL';

export const FETCH_NORMALDLVRYSTATUS_INIT_ACTION =
  'FETCH_NORMALDLVRYSTATUS_INIT_ACTION';
export const FETCH_NORMALDLVRYSTATUS_SUCCESS_ACTION =
  FETCH_NORMALDLVRYSTATUS_INIT_ACTION + '_SUCCESS';
export const FETCH_NORMALDLVRYSTATUS_FAIL_ACTION =
  FETCH_NORMALDLVRYSTATUS_INIT_ACTION + '_ERROR';

export const FETCH_NORMALORDERSHIPPED_INIT_ACTION =
  'FETCH_NORMALORDERSHIPPED_INIT_ACTION';
export const FETCH_NORMALORDERSHIPPED_SUCCESS_ACTION =
  FETCH_NORMALORDERSHIPPED_INIT_ACTION + '_SUCCESS';
export const FETCH_NORMALORDERSHIPPED_FAIL_ACTION =
  FETCH_NORMALORDERSHIPPED_INIT_ACTION + '_ERROR';

export const CHANGE_NORMALPAYMENTSTATUS_INIT_ACTION =
  'CHANGE_NORMALPAYMENTSTATUS_INIT_ACTION';
export const CHANGE_NORMALPAYMENTSTATUS_SUCCESS_ACTION =
  CHANGE_NORMALPAYMENTSTATUS_INIT_ACTION + '_SUCCESS';
export const CHANGE_NORMALPAYMENTSTATUS_ERROR_ACTION =
  CHANGE_NORMALPAYMENTSTATUS_INIT_ACTION + '_ERROR';

export const PDF_REPORT_INIT_ACTION = 'PDF_REPORT_INIT_ACTION';
export const PDF_REPORT_SUCCESS_ACTION = PDF_REPORT_INIT_ACTION + '_SUCCESS';
export const PDF_REPORT_FAIL_ACTION = PDF_REPORT_INIT_ACTION + '_ERROR';

export const SEARCH_NORMALORDERITEMS_INIT_ACTION =
  'SEARCH_NORMALORDERITEMS_INIT_ACTION';
export const SEARCH_NORMALORDERITEMS_SUCCESS_ACTION =
  SEARCH_NORMALORDERITEMS_INIT_ACTION + '_SUCCESS';
export const SEARCH_NORMALORDERITEMS_FAIL_ACTION =
  SEARCH_NORMALORDERITEMS_INIT_ACTION + '_ERROR';

export function fetchNormalOrders(value) {
  // console.log(value);
  return {
    type: FETCH_NORMALORDERS_INIT_ACTION,
    value: value,
  };
}

export function newpageSelected(value) {
  return {
    type: FETCH_NORMALORDERS_INIT_ACTION,
    value: value,
  };
}

export function inprogressOrders(value) {
  return {
    type: FETCH_INPROGRESSORDERS_INIT_ACTION,
    value: value,
  };
}

export function progresspageSelected(value) {
  return {
    type: FETCH_INPROGRESSORDERS_INIT_ACTION,
    value: value,
  };
}

export function deliveredOrders(value) {
  return {
    type: FETCH_DELIVEREDORDERS_INIT_ACTION,
    value: value,
  };
}

export function deliveredpageSelected(value) {
  return {
    type: FETCH_DELIVEREDORDERS_INIT_ACTION,
    value: value,
  };
}

export function cancelledOrders(value) {
  return {
    type: FETCH_CANCELLEDORDERS_INIT_ACTION,
    value: value,
  };
}

export function cancelledpageSelected(value) {
  return {
    type: FETCH_CANCELLEDORDERS_INIT_ACTION,
    value: value,
  };
}
export function ChemistNormalOrdersview(value) {
  return {
    type: FETCH_NORMALORDERVIEW_INIT_ACTION,
    value: value,
  };
}
export function NormalOrderEdit(value) {
  return {
    type: EDIT_NORMALORDER_INIT_ACTION,
    value: value,
  };
}
export function NormalOrderReject(value) {
  return {
    type: FETCH_NORMALORDERREJECT_INIT_ACTION,
    value: value,
  };
}

export function Totalitemretrieval(value) {
  return {
    type: GET_COMPLETEITEMS_INIT_ACTION,
    value: value,
  };
}

export function manualInvoice(value) {
  return {
    type: CREATE_INVOICE_INIT_ACTION,
    value: value,
  };
}
export function fetchNormalorderdlryStatus() {
  return {
    type: FETCH_NORMALDLVRYSTATUS_INIT_ACTION,
  };
}
export function NormalordersShipped(value) {
  return {
    type: FETCH_NORMALORDERSHIPPED_INIT_ACTION,
    value: value,
  };
}
export function itempageSelected(value) {
  // console.log("itempageSelected====================");
  return {
    type: FETCH_NORMALORDERVIEW_INIT_ACTION,
    value: value,
  };
}
export function itemViewpageSelected(value) {
  // console.log("itempageSelected====================");
  return {
    type: FETCH_NORMALORDERVIEW_INIT_ACTION,
    value: value,
  };
}

export function changePaymentstatusnormal(value) {
  return {
    type: CHANGE_NORMALPAYMENTSTATUS_INIT_ACTION,
    value: value,
  };
}
export function pdfFullData(value) {
  return {
    type: PDF_REPORT_INIT_ACTION,
    value: value,
  };
}
export function searchChemistitems(value) {
  console.log('#########22222222222222222', value);
  return {
    type: SEARCH_NORMALORDERITEMS_INIT_ACTION,
    value: value,
  };
}
